import { isMobileOnly, isTablet, isDesktop } from "react-device-detect";

export const detectDeviceType = () => {
  if (isMobileOnly) return "mobile";

  // For some reason ipad tablet returns as a desktop and tablet
  // need to make sure tablet is flase to safely assume it's a desktop
  if (isDesktop && !isTablet) return "browser";
  return "tablet";
};
